import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/paySuccess.png'


const _withScopeId = n => (_pushScopeId("data-v-04c45b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "paySuccess" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "payBtnDec" }

import { ref, onMounted } from "vue";

import { getCookie } from "@/utils/cookies";
import { payResult, payPost } from "@/api/pay";
import { downloadDecHub } from "@/api/download";
import "@/style/bind.scss";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { PayMentType } from "@/types/pay";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayMent',
  setup(__props) {

const router = useRouter();
const orderNum: any = router.currentRoute.value.query.out_trade_no;
const store = useStore();
const isMobile = store.state.isMobile;
const month = ref("");
const route = useRoute();
const loading = ref(false);
const isHidden = ref(false);
onMounted(() => {
  if (orderNum) {
    getSuccessPay(orderNum);
  }
});
function getSuccessPay(id: string) {
  payResult(id).then((res: any) => {
    //1 成功   其他属于失败
    if (res.data.orderStatus === 1) {
      month.value = res.data.serviceNum;
      isHidden.value = true;
    } else {
      router.push({
        name: "purchase-services",
        params: {
          errorCode: 1,
        },
      });
    }
  });
}

// 下载地址
const goDowload = () => {
  if (isMobile) {
    store.dispatch("changeMobileDownloadTips", true);
    return;
  }
  if (!getCookie("token")) {
    store.commit("showLogin");
    return;
  }
  store.dispatch("download/downloadDecHub");
};

const openInformation = () => {
  const toPath = isMobile ? "/userCenter/account/order" : "/userCenter/account";
  router.push({ path: toPath });
};

const getPaypalResult = () => {
  loading.value = true;
  const orderNum = route.query.orderNo as string;
  let params: PayMentType = {
    payType: "2",
    orderNo: orderNum,
    paypalCaptureFlag: 1,
  };
  payPost(params).then((res: any) => {
    if (res.code == 0) {
      let Interval = setInterval(() => {
        payResult(orderNum).then((payResult: any) => {
          // console.log(payResult, res);
          month.value = payResult.data.serviceNum;
          if (res.data.orderStatus !== 4 || payResult.data.orderStatus !== 4) {
            clearInterval(Interval);
            loading.value = false;
          }
        });
      }, 2000);
      isHidden.value = true;
    }
  });
};
if (route.query.orderNo) {
  getPaypalResult();
}

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (isHidden.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["bindMobile bindBox", { 'mobile-payment': _unref(isMobile) }]),
        "element-loading-background": "rgba(255, 255, 255, 0.1)"
      }, [
        (_unref(isMobile))
          ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
              key: 0,
              title: _ctx.$t('user_center.payment_success'),
              isShowBackButton: false
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                (!_unref(isMobile))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("user_center.payment_success")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "payText",
                innerHTML: 
          _ctx.$t('user_center.payment_succeeeded').replace(
            'XXX',
            `<span> ${month.value} </span>`
          )
        
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("user_center.help1")) + " ", 1),
                  _createVNode(_component_router_link, { to: {
              path: '/help',
            } }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("user_center.help2")), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("user_center.help3")), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", { onClick: openInformation }, _toDisplayString(_ctx.$t("user_center.view_the_order")), 1),
                  _createElementVNode("button", {
                    class: "download",
                    onClick: goDowload
                  }, _toDisplayString(_ctx.$t("header.DECDow")), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass({ 'pay-loading-back': loading.value })
            }, null, 2))
      ], 2)), [
        [_directive_loading, loading.value]
      ])
    : _createCommentVNode("", true)
}
}

})